module.exports = __webpack_public_path__ + "static/flesh_golem-721713a321544840184e39e216868336.jpeg";